<main class="maintenance-main">
  <div class="maintenance-container">
    <!-- Left side - Brand -->
    <div class="brand-side">
      <div class="brand-content">
        <img src="assets/img/atlas.webp" alt="Atlas" class="brand-logo" />
        <h2 class="brand-title">Atlas / Ἄτλας</h2>
        <p class="brand-description">
          Portale Merci · Bertani Trasporti
        </p>
      </div>
    </div>

    <!-- Right side - Maintenance message -->
    <div class="message-side">
      <div class="message-content">
        <img src="img/logo-bertani-color.svg" alt="Bertani Trasporti" class="bertani-logo" />

        <div class="maintenance-heading">
          <div class="maintenance-icon">
            <i class="fas fa-tools"></i>
          </div>
          <h1 class="main-title">Sito in manutenzione</h1>
        </div>

        <p class="main-subtitle">
          Stiamo eseguendo alcuni lavori per migliorare il servizio.<br>
          Il portale sarà nuovamente disponibile a breve.
        </p>

        <div class="maintenance-window">
          <i class="fas fa-clock window-icon"></i>
          <div class="window-text">
            <span class="window-label">Finestra di manutenzione</span>
            <strong class="window-time">dalle 16:00 alle 17:00</strong>
          </div>
        </div>

        <div class="maintenance-status">
          <span class="status-dot"></span>
          <span>Servizio temporaneamente non disponibile</span>
        </div>

        <button type="button" class="btn-reload" (click)="reload()">
          <i class="fas fa-sync-alt me-2"></i>
          Riprova
        </button>

        <div class="maintenance-footer">
          <p class="support-line">
            Per assistenza contatta:
            <a href="mailto:supporto.ricambi@bertanitrasporti.it">supporto.ricambi&#64;bertanitrasporti.it</a>
          </p>
        </div>
      </div>
    </div>
  </div>
</main>
